module.exports = __webpack_public_path__ + "static/media/12.11c823c1.jpeg";